import NavigationTabs from '@shared/components/navigation/navigation-tabs';
import NavTab from '@shared/components/navigation/navigation-tabs/nav-tab';
import { html, nothing } from '@shared/utils/rendering/html';
import { MainDocumentationPagesConfig } from '@core/configs/routes/dashboard-tabs/dashboard-tabs.config';
import { useState } from 'preact/hooks';
import RdarrReImagined from './rdarr-reimagined';
import { useNavigate } from '@core/utils/context/navigation-context';
import EvidenceBasedApproach from './evidence-based-approach';
import SarbSelfAssessment from './sarb-self-assessment';
import { DashboardTabs } from '@core/constants/routing/tabs.constants';
import { useFeatureChecks } from '@core/utils/features/feature-context';

// Dashboard remounts on each route change (key prop in rdarr.routes.js) so
// useState(activePage) picks up the correct initial tab — no useEffect needed.
// This matches the ERM-Portal Admin pattern exactly.
const Dashboard = ({ activePage }) => {
    const { onNavigate } = useNavigate();
    const { useFeature } = useFeatureChecks();
    const sarbEnabled = useFeature('sarb.selfAssessment.enabled', true);

    const visibleTabs = sarbEnabled
        ? MainDocumentationPagesConfig
        : MainDocumentationPagesConfig.filter((t) => t.id !== DashboardTabs.sarbSelfAssessment);

    // If the feature is disabled and we land on the SARB route, fall back to the first tab.
    const resolvedPage =
        !sarbEnabled && activePage?.id === DashboardTabs.sarbSelfAssessment
            ? MainDocumentationPagesConfig[0]
            : activePage;

    const [activeTab, setActiveTab] = useState(resolvedPage ?? MainDocumentationPagesConfig[0]);
    const [isFullScreen, setIsFullScreen] = useState(false);

    return html`
        ${
            !isFullScreen
                ? html`
            <h1 class="title mb-3">RDARR Central Office</h1>
            <${NavigationTabs}>
                ${visibleTabs.map(
                    (tab) =>
                        html`<${NavTab}
                            activeTab=${activeTab}
                            setActiveTab=${setActiveTab}
                            tabDetails=${{
                                ...tab,
                                event: () => onNavigate(tab.path),
                            }}
                        />`
                )}
            </${NavigationTabs}>
        `
                : nothing
        }
        ${activeTab?.id === DashboardTabs.rdarrReimagined ? html`<${RdarrReImagined} />` : nothing}
        ${activeTab?.id === DashboardTabs.evidenceBasedApproach ? html`<${EvidenceBasedApproach} />` : nothing}
        ${sarbEnabled && activeTab?.id === DashboardTabs.sarbSelfAssessment ? html`<${SarbSelfAssessment} onFullScreen=${setIsFullScreen} />` : nothing}
    `;
};

export default Dashboard;
